import { Table, TableBody, TableCell, TableHead, TableRow } from "@mui/material";
import { FingerModel, Operation, OperationModality } from "neurotec-megamatcherid-management-client"
import OverviewRow from "./OverviewRow";
import { handleCutStringHelper } from "../../helpers/displayStringHelpers";

const evenColor = "#fefefe"
const oddColor = "#fafafa"
const issueColor = "#f8e05e"

interface IOverviewProps {
    modality?: OperationModality
    operation: Operation
    isOperation?: boolean
    subjectId?: string
    adjudication?: boolean
    issueLiveness?: boolean
    issueAge?: boolean
    finalDecision?: string
    issues?: string[],
    qualities?: number[],
    finger?: FingerModel
}

const OverviewInfo: React.FC<IOverviewProps> = (props) => {

    const getOperationInfo = () => (
        <>
        {props.subjectId? <OverviewRow property="SubjectId" value={props.subjectId} tooltip={props.subjectId} color={oddColor} type="string"/> : null}
        <OverviewRow property="Insert date" value={props.operation.date} color={evenColor} type="date"/>
        {props.isOperation? <OverviewRow property="Operation type" value={props.operation.operationType?.toString()} color={oddColor} type="type"/> : null}
        {props.isOperation? <OverviewRow property="Status" value={props.operation.status?.toString()} color={evenColor} type="status"/> : null }
        {props.modality === "FACE_MODALITY"? <OverviewRow property="Liveness mode" value={props.operation.livenessMode?.toString()} color={oddColor} type="liveness"/> : null}
        {props.modality === "FACE_MODALITY"? <OverviewRow property="Estimated age" value={props.operation.age} color={evenColor} type="number"/> : null}
        {props.modality === "FACE_MODALITY"? <OverviewRow property="Yaw" value={props.operation.yaw?.toFixed(2)?.toString()} color={oddColor} type="number"/> : null}
        {props.modality === "FACE_MODALITY"? <OverviewRow property="Roll" value={props.operation.roll?.toFixed(2)?.toString()} color={evenColor} type="number"/> : null}
        {props.modality === "FACE_MODALITY"? <OverviewRow property="Pitch" value={props.operation.pitch?.toFixed(2).toString()} color={oddColor} type="number"/> : null}
        {props.modality === "FACE_MODALITY"? <OverviewRow property="Liveness target yaw" value={props.operation.livenessTargetYaw} color={evenColor} type="number"/> : null}
        {props.modality === "FACE_MODALITY"? <OverviewRow property="Liveness score" value={props.operation.livenessScore} color={oddColor} type="number"/> : null}
        {props.qualities ? <OverviewRow property="Quality" value={props.qualities} color={oddColor} type="number[]"/> : <OverviewRow property="Quality" value={props.operation.quality} color={evenColor} type="number"/>}
        <OverviewRow property="UUID" value={props.operation.uuid?.toString()} tooltip={props.operation.uuid?.toString()} color={oddColor} type="longstring"/>
        {props.finger && props.finger.uuid? <OverviewRow property="Finger UUID" value={props.finger.uuid.toString()} color={oddColor} type="string"/> : null}
        <OverviewRow property="Modality type" value={props.operation.modality?.toString()} color={evenColor} type="modality"/>
        {props.finger && props.finger.position? <OverviewRow property="Position" value={handleCutStringHelper("FINGER_POSITION_", props.finger.position)} color={oddColor} type="string"/> : null}
        {props.modality === "FINGERS_MODALITY"? <OverviewRow property="Biometric data source" value={handleCutStringHelper("BIOMETRIC_DATA_SOURCE_", props.operation.biometricDataSource)} color={evenColor} type="string"/> : null}
        </>
    )

    const getAdjudicationInfo = () => (
        <>
        <OverviewRow property="Insert date" value={props.operation.date} color={evenColor} type="date"/>
        {props.modality === "FACE_MODALITY"? <OverviewRow property="Estimated age" value={props.operation.age} color={props.issueAge? issueColor : oddColor} type="number"/> : null}
        {props.modality === "FACE_MODALITY"? <OverviewRow property="Liveness mode" value={props.operation.livenessMode?.toString()} color={props.issueLiveness? issueColor : evenColor} type="liveness"/> : null}
        {props.modality === "FACE_MODALITY"? <OverviewRow property="Liveness score" value={props.operation.livenessScore} color={props.issueLiveness? issueColor : oddColor} type="number"/> : null}
        {props.finalDecision? <OverviewRow property="Final decision" value={props.finalDecision} color={evenColor} type="decision"/> : null}
        {props.issues? <OverviewRow property="Issues" value={props.issues} color={oddColor} type="issue"/> : null}
        </>
    )

    return (
        <Table>
            <TableHead>
                <TableRow style={{paddingTop: "0px"}}>
                    <TableCell style={{paddingTop: "0px"}}>
                        Property
                    </TableCell>
                    <TableCell style={{paddingTop: "0px"}}>
                        Value
                    </TableCell>
                </TableRow>
            </TableHead>
            <TableBody>
                {props.adjudication? (getAdjudicationInfo()) : (getOperationInfo())}
            </TableBody>
        </Table>
    )
}

export default OverviewInfo